import React from 'react';
// @ts-ignore
import styles from './TimelineGrid.module.scss';
import TimelineGridLegend from './TimelineGridLegend';
import TimelineGridColumn from './TimelineGridColumn';
import { ITimelineGridColumn } from '../../Models/TimelineGrid/ITimelineGridColumn';
import { ITimelineGridLegendItem } from '../../Models/TimelineGrid/ITimelineGridLegendItem';

interface ITimelineGrid {
	items: ITimelineGridColumn[];
	legendItems: ITimelineGridLegendItem[];
	showLegend?: boolean;
}

export default function TimelineGrid(props: ITimelineGrid) {
	const { items, legendItems, showLegend = false } = props;

	return (
		<div className={styles.wrapper}>
			{showLegend && <TimelineGridLegend items={legendItems} />}
			<div className={styles.columnsWrapper}>
				{items &&
					items.map((item, index) => (
						<React.Fragment key={index}>
							<TimelineGridColumn title={item.title} items={item.items} />
						</React.Fragment>
					))}
			</div>
		</div>
	);
}
